export class ApplicationConstants {
	public static readonly MAX_MODELS_FOR_COMPARISON = 3;
	public static readonly HIGHLIGHTED = 'highlighted';
	public static readonly ME_FILTER_KEY = 'meFilterKey';
	public static readonly APPLICABILITY_PORTFOLIO = 'portfolio';
	public static readonly USER_ACCESS_LEVEL = {
		VERIFIED_FP: 'VERIFIED_FP',
		VERIFIED_INSTL: 'VERIFIED_INSTL',
		MASTER_SYSTEM: 'BLK'
	};
}
